module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._l((_vm.summaries), function(summary, key) {
    return [(!_vm.categories[key].parentId) ? _c('div', {
      class: [
        'flexRow categorySummary',
        _vm.categories[key].children && _vm.categories[key].showChildren ? 'hasChildren' : '' ]
    }, [_c('category-details-block', {
      attrs: {
        "category": _vm.categories[key],
        "completed": summary.totalCompleted,
        "quota": summary.totalQuota
      }
    }), _vm._v(" "), _c('static-block-row', {
      staticClass: "staticBlockRow",
      attrs: {
        "completed": !_vm.categories[key].showChildren ? summary.totalCompleted : summary.completed,
        "quota": !_vm.categories[key].showChildren ? summary.totalQuota : summary.quota,
        "color": _vm.categories[key].color
      }
    })], 1) : _vm._e(), _vm._v(" "), (_vm.categories[key].showChildren) ? _vm._l((Object.keys(_vm.categories[key].children || {})), function(childId) {
      return _c('div', {
        staticClass: "flexRow subcategory"
      }, [_c('subcategory-details-block', {
        attrs: {
          "categoryId": childId
        }
      }), _vm._v(" "), _c('static-block-row', {
        staticClass: "staticBlockRow",
        attrs: {
          "completed": _vm.summaries[childId].completed,
          "quota": _vm.summaries[childId].quota,
          "color": _vm.getCategoryColor(childId)
        }
      })], 1)
    }) : _vm._e()]
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-06c291b6!./~/vue-loader/lib/selector.js?type=template&index=0!./dev/src/views/CumulativeWeekView.vue
// module id = ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-06c291b6!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./dev/src/views/CumulativeWeekView.vue
// module chunks = 0